import { NgModule } from "@angular/core";
import { AsyncPipe, CommonModule, DatePipe } from "@angular/common";
import { RecruiterRoutingModule } from "./recruiter-routing.module";
import { RouterModule } from "@angular/router";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { HttpClientModule, HTTP_INTERCEPTORS } from "@angular/common/http";
import { ModalModule } from "ngx-bootstrap/modal";
import { PaginationModule } from "ngx-bootstrap/pagination";
import { BsDatepickerModule } from "ngx-bootstrap/datepicker";
import { NgxSpinnerModule } from "ngx-spinner";
import { ImageCropperModule } from "ngx-image-cropper";
import { NgxMaskModule } from "ngx-mask";
import { PhoneMaskDirective } from "../directive/phone-mask.directive";
import { InterceptorService } from "../services/interceptor.service";
import { DataSharingService } from "../services/data.share.service";
import { DateagoPipe } from "../pipe/dateago.pipe";
import { CapitalizeFirstDirective } from "../directive/capitalize-first.directive";
import { NumberOnlyDirective } from "../directive/number-only.directive";
// 
import { CommonRecuriterComponent } from "../shared/common-recuriter";
import { CompanyProfileComponent } from "./company-profile/company-profile.component";
import { SubscriptionPlansComponent } from "./subscription-plans/subscription-plans.component";
import { InventoryComponent } from "./subscription-plans/inventory/inventory.component";
import { CheckoutComponent } from "./subscription-plans/checkout/checkout.component";
import {UploadFileComponent} from "./upload-file/upload-file.component";

import { NgxStripeModule } from "ngx-stripe";
import { EditProfileComponent } from "./edit-profile/edit-profile.component";
import { GooglePlaceModule } from "ngx-google-places-autocomplete";
import { AddressComponent } from "./subscription-plans/address/address.component";
import { NgxSliderModule } from "@angular-slider/ngx-slider"; 

@NgModule({
  declarations: [ 
    // CapitalizeFirstDirective,
    // NumberOnlyDirective,
    // CommonRecuriterComponent,
    // PhoneMaskDirective,
    UploadFileComponent,
    CompanyProfileComponent,
    SubscriptionPlansComponent,
    InventoryComponent,
    CheckoutComponent,
    EditProfileComponent,
    AddressComponent, 
  ],
  imports: [
    NgxStripeModule.forRoot("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"),
    RouterModule,
    CommonModule,
    RecruiterRoutingModule,
    FormsModule,
    CommonModule,
    NgbModule,
    ReactiveFormsModule,
    HttpClientModule,
    ModalModule.forRoot(),
    PaginationModule.forRoot(),
    BsDatepickerModule.forRoot(),
    NgxSpinnerModule,
    
    NgxSliderModule,
    ImageCropperModule,
    NgxMaskModule.forRoot(),
    GooglePlaceModule
  ],
  exports:[
    NgxStripeModule
  ],
  providers: [
    AsyncPipe,
    DatePipe,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: InterceptorService,
      multi: true,
    },
    NgxSpinnerModule,
    DataSharingService,
  ],
  bootstrap: []
})
export class RecruiterInternalModule { }
